import { Box, Button, Typography } from "@mui/joy";
import { Link as RouterLink } from "react-router-dom";

export default function NotAuthorized() {
    return (
        <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            minHeight={"60vh"}
            gap={2}
        >
            <Typography level="h2">Not authorized</Typography>
            <Typography level="body-md" textAlign={"center"}>
                You don’t have permission to view this page or perform this action.
            </Typography>
            <Button component={RouterLink} to="/" variant="soft">
                Go to dashboard
            </Button>
        </Box>
    );
}
